import React, { useEffect, useState } from 'react';
import { Cpu, RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export const FidemModelSelect = ({ value, onChange, disabled, prefix }) => {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const load = () => { setError(false); api.get('/fidem/models').then(r => setData(r.data)).catch(() => setError(true)); };
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (error) return <button data-testid={`${prefix}-models-retry`} onClick={load} className="flex items-center gap-2 text-xs text-rose-300"><RefreshCw size={14} />Reintentar modelos</button>;
  return <label className="flex min-w-0 max-w-full items-center gap-2 rounded-lg border border-slate-700 px-3 py-2 text-xs text-slate-200">
    <Cpu size={15} className="shrink-0 text-amber-300" />
    <select data-testid={`${prefix}-model-select`} aria-label="Modelo de conversación" value={value} onChange={e => onChange(e.target.value)} disabled={disabled || !data} className="min-w-0 max-w-full bg-slate-900 outline-none disabled:opacity-50">
      {!data && <option value={value}>Cargando modelos…</option>}
      {data?.models.map(m => <option key={m.id} value={m.id} disabled={!m.configured}>{m.label}{!m.configured ? ' · pendiente' : ''}</option>)}
    </select>
  </label>;
};